<template>
  <div class="parallel-forum" @mouseenter="mouseEnter" @mouseleave="mouseLeave">
    <ModuleNav :normal="nav.normal" :hover="nav.hover" :isInModule="isInModule"/>
    <div class="content">
      <a :href="link" target="_blank">
        <img :src="image">
      </a>
    </div>
  </div>
</template>

<script>
  import ModuleNav from './ModuleNav';
  import { mapState } from 'vuex';

  export default {
    name: 'ParallelForum',
    components: { ModuleNav },
    computed: {
      ...mapState({
        link: state => state.parallelForum.link,
        image: state => state.parallelForum.image,
        nav: state => state.parallelForum.nav,
      })
    },
    data() {
      return {
        isInModule: false
      };
    },
    methods: {
      mouseEnter() {
        this.isInModule = true;
      },
      mouseLeave() {
        this.isInModule = false;
      }
    }
  };
</script>

<style scoped lang="less">
  .parallel-forum {
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;

    .content {
      width: 80.5vh;
      height: 85vh;
      margin-left: 8vh;

      a {
        display: block;
        height: 100%;

        img {
          height: 100%;
        }
      }
    }
  }
</style>
